import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./layouts/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Stock from "./pages/Stock";
import MedicineDetail from "./pages/MedicineDetail";
import Sales from "./pages/Sales";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Branches from "./pages/Branches";
import ActivityLog from "./pages/ActivityLog";
import Accounts from "./pages/Accounts";
import Settings from "./pages/Settings";
import Vendors from "./pages/Vendors";
import VendorLedger from "./pages/VendorLedger";
import Purchases from "./pages/Purchases";
import InvoicePrint from "./pages/InvoicePrint";
import ReportPrint from "./pages/ReportPrint";
import StockForm from "./pages/StockForm";
import StockBulkImport from "./pages/StockBulkImport";
import Customers from "./pages/Customers";
import CustomerLedger from "./pages/CustomerLedger";
import SalesHistory from "./pages/SalesHistory";
import MasterCatalog from "./pages/MasterCatalog";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Standalone printable invoice page (no sidebar) */}
          <Route path="/invoice/:id" element={
            <ProtectedRoute><InvoicePrint /></ProtectedRoute>
          } />
          {/* Standalone printable report page (no sidebar) */}
          <Route path="/print/report/:type" element={
            <ProtectedRoute><ReportPrint /></ProtectedRoute>
          } />

          <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/stock/new" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier"]}><StockForm /></ProtectedRoute>
            } />
            <Route path="/stock/edit/:id" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier"]}><StockForm /></ProtectedRoute>
            } />
            <Route path="/stock/bulk-import" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier"]}><StockBulkImport /></ProtectedRoute>
            } />
            <Route path="/medicine/:id" element={<MedicineDetail />} />
            <Route path="/sales" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier"]}><Sales /></ProtectedRoute>
            } />
            <Route path="/sales/history" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><SalesHistory /></ProtectedRoute>
            } />
            <Route path="/purchases" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><Purchases /></ProtectedRoute>
            } />
            <Route path="/vendors" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><Vendors /></ProtectedRoute>
            } />
            <Route path="/vendor/:id" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><VendorLedger /></ProtectedRoute>
            } />
            <Route path="/customers" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><Customers /></ProtectedRoute>
            } />
            <Route path="/customer/:id" element={
              <ProtectedRoute roles={["admin", "branch_head", "cashier", "accountant"]}><CustomerLedger /></ProtectedRoute>
            } />
            <Route path="/reports" element={<Reports />} />
            <Route path="/accounts" element={
              <ProtectedRoute roles={["admin", "branch_head", "accountant"]}><Accounts /></ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>
            } />
            <Route path="/branches" element={
              <ProtectedRoute roles={["admin"]}><Branches /></ProtectedRoute>
            } />
            <Route path="/master-catalog" element={
              <ProtectedRoute roles={["admin"]}><MasterCatalog /></ProtectedRoute>
            } />
            <Route path="/activity" element={
              <ProtectedRoute roles={["admin"]}><ActivityLog /></ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute roles={["admin", "branch_head"]}><Settings /></ProtectedRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
